
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import './App.css';
import LoggedInHome from './routes/LoggedInHome';
import SignUp from './routes/SignUp';
import Questionarrie from './routes/Questionarrie';
import { useCookies } from 'react-cookie';
import Login from './routes/Login';
import Logout from './routes/Logout';
import Dashboard from './routes/Dashboard';
import modalContext from './context/ModalContext';
import { useState } from 'react';
import Saved from './routes/Saved';
import {Toaster} from 'react-hot-toast';
import Aboutus from './routes/Aboutus';
import Error from './routes/Error';
import Delete from './routes/Delete';

function App() {
  const [cookie, setCookie] = useCookies(["token"]);
  const [showModal, setShowModal] = useState(false);
  const [modalDetails, setModalDetails] = useState(null);
  const [profileDetails, setProfileDetails] = useState(null);
  const [modal, setModal] = useState(false);
  const [load, setLoad] = useState(false);
  return (
    <div className="App">
      <BrowserRouter>
      <Toaster />
      {cookie.token ? (
        <modalContext.Provider value={{showModal, setShowModal, modalDetails, setModalDetails, profileDetails, setProfileDetails, modal, setModal, load, setLoad}}>
        <Routes>
        <Route path='/questionnaire' element={<Questionarrie />} />
        <Route path='/loggedinhome' element={<LoggedInHome />} />
        <Route path='/logout' element={<Logout />} />
        <Route path='/dashboard' element={<Dashboard />} />
        <Route path='/saved' element={<Saved />} />
        <Route path='*' element={<LoggedInHome />} />
        <Route path='/aboutus' element={<Aboutus />} />
        <Route path='/delete' element={<Delete />} />
        <Route path='/err' element={<Error />} />
      </Routes>
      </modalContext.Provider>
      ):(
        <modalContext.Provider value={{load, setLoad}}>
        <Routes>
          <Route path='/aboutus' element={<Aboutus />} />
          <Route path='/err' element={<Error />} />
        <Route path='/loggedinhome' element={<LoggedInHome />} />
        <Route path='/signup' element={<SignUp />} />
        <Route path='/login' element={<Login />} />
        <Route path='*' element={<LoggedInHome />} />
      </Routes>
      </modalContext.Provider>
      )}
      </BrowserRouter>
    </div>
  );
}

export default App;
